export const uni_location = "LOCATION_RESPONSE"
export const guest_article = "GUEST_ARTICLE_V2"
export const applicability = "APPLICABILTY"
export const status = "STATUS"
export const permission_name = "PERMISSION_NAME"
